<template>
  <li v-if="show"
      ref="li"
      v-bind="attrsLi"
      :class="{'active': hasCurrentPage || isOpenChild}"
      :to="data.to"
  >
    <a v-b-toggle="id">
      <i v-if="data.icon" :class="data.icon"></i>
      <slot name="label">{{ data.label }}</slot>
      <span v-if="hasChild" class="fa fa-chevron-down"></span>
    </a>
    <sidebar-menu v-if="hasChild"
                  :id="id"
                  ref="childMenu"
                  v-model="isOpenChild"
                  child-menu>
      <slot>
        <sidebar-menu-item v-for="item in data.menuItems" ref="menuItems" :data="item"/>
      </slot>
    </sidebar-menu>
  </li>
</template>

<script>
import SidebarMenu from "@/components/layout/SideBar/SidebarMenu";
import checkMountedMixins from "@/mixins/checkMountedMixins";

export default {
  name: "SidebarMenuItem",
  mixins: [
    checkMountedMixins
  ],
  components: {
    SidebarMenu
  },
  props: {
    icon: String,
    label: String,
    permission: String,
    data: Object
  },
  computed: {
    attrsLi() {
      const $attrs = this.$attrs
      let attr = {
        ...$attrs
      }
      if (!this.hasChild) {
        attr.is = 'router-link';
        attr.tag = 'li';
      }
      return attr;
    },
    $li() {
      return $(this.$refs.li)
    },
    $BODY() {
      return $('body');
    },

    $SIDEBAR_MENU() {
      return $('#sidebar-menu');
    },
    // hasActive() {
    //   console.log(this.$el)
    //   let hasActive = this.$li.hasClass("current-page") || this.$li.find('li').is('.current-page');
    //   return hasActive;
    // },
    id() {
      return 'sideBar-' + this._uid;
    },
    show() {
      let show = true;
      if (this.hasChild && this.isMounted) {
        show = show && this.$refs.menuItems.some(x => x.isShow());
      } else {
        show = show && !this.data.permission || this.hasPermission(this.data.permission);
      }
      return show;
    },
    hasChild() {
      return (this.data && this.data.menuItems && this.data.menuItems.length) || this.$slots.default;
    }
  },
  data() {
    return {
      hasCurrentPage: false,
      isOpenChild: false,
    }
  },
  methods: {
    isShow() {
      return this.show;
    },
  },
  mounted() {
    this.data.icon = this.icon || this.data.icon;
    this.data.label = this.label || this.data.label;
    this.data.permission = this.permission || this.data.permission;
  }
}
</script>

<style scoped>

</style>